import React, { memo, useRef, useEffect } from "react";
import ThumbNail from "../../components/thumbNail/ThumbNail";
import musicPlayerStore from "../../zustand/musicPlayer.store";
import { MEDIA_URL } from "../../axios";
import styles from "./MiniPlayer.module.scss";

const MiniPlayIcon = () => (
  <svg width="22" height="22" viewBox="0 0 24 24" fill="white">
    <polygon points="6,3 20,12 6,21" />
  </svg>
);

const MiniPauseIcon = () => (
  <svg width="22" height="22" viewBox="0 0 24 24" fill="white">
    <rect x="5" y="3" width="5" height="18" rx="1" />
    <rect x="14" y="3" width="5" height="18" rx="1" />
  </svg>
);

const MiniPlayer = ({ onTap }) => {
  const {
    songs,
    currentSongIndex,
    isPlaying,
    setIsPlaying,
    searchedSong,
    isLoading,
  } = musicPlayerStore((state) => ({
    songs: state.songs,
    currentSongIndex: state.currentSongIndex,
    isPlaying: state.isPlaying,
    setIsPlaying: state.setIsPlaying,
    searchedSong: state.searchedSong,
    isLoading: state.isLoading,
  }));

  const progressRef = useRef(null);

  useEffect(() => {
    const id = setInterval(() => {
      const engine = window.__4playEngine;
      if (!engine || !progressRef.current) return;
      const ref = engine.getCurrentAudioRef();
      if (!ref?.current) return;
      const pct = (ref.current.currentTime / ref.current.duration) * 100;
      if (!isNaN(pct)) progressRef.current.style.width = pct + '%';
    }, 500);
    return () => clearInterval(id);
  }, []);

  if (!songs?.length && !isLoading) return null;

  const song = searchedSong || songs?.[currentSongIndex];
  if (!song) return null;

  const handlePlayPause = (e) => {
    e.stopPropagation();
    if (window.__4playEngine) window.__4playEngine.primeElements();
    const willPlay = !isPlaying;
    setIsPlaying(willPlay);
    if (willPlay && window.__4playEngine) {
      const ref = window.__4playEngine.getCurrentAudioRef();
      if (ref?.current) {
        ref.current.muted = false;
        window.__4playEngine.setGainValue(window.__4playEngine.getCurrentGain(), 1);
        ref.current.play().catch(() => {});
      }
    }
  };

  return (
    <div className={styles.container} onClick={onTap}>
      <div className={styles.progressLine} ref={progressRef} />
      <div className={styles.swipeHint}>
        <div className={styles.swipeBar} />
      </div>
      <div className={styles.thumbnail}>
        <ThumbNail
          name={song.title}
          color={song.color}
          imgSrc={`${MEDIA_URL}/songs_images/${song.imageFileName}`}
          hasImage={!!song.imageFileName}
          imageFileName={song.imageFileName}
        />
      </div>
      <div className={styles.info}>
        <p className={styles.title}>{song.title}</p>
        <p className={styles.artist}>{song.artist}</p>
      </div>
      <button className={styles.playBtn} onClick={handlePlayPause}>
        {isPlaying ? <MiniPauseIcon /> : <MiniPlayIcon />}
      </button>
    </div>
  );
};

export default memo(MiniPlayer);
